import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';

const QPCreatorGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { user } = useAuth();
  console.log(user);



    if(user.user_group !== "qp_creator" ){
        return <Redirect to="/accessdenied" />;
      }
     
  //if (isAuthenticated && message.data.message == "NEW_PASSWORD_REQUIRED") {

  //return <Redirect to="/app/account/reset_password"/>;
  // }

  return <>{children}</>;
};

QPCreatorGuard.propTypes = {
  children: PropTypes.node
};

export default QPCreatorGuard;
